import { CircularLoader } from "@ui/loaders";

import { SETTINGS_PAGE_LOADER_TEST_ID } from "@octopus-settings/constants/testIds/settingsPage";
import useStyles from "./PageLoader.styles";

const PageLoader = () => {
  const { classes } = useStyles();

  return (
    <div className={classes.loader} data-testid={SETTINGS_PAGE_LOADER_TEST_ID}>
      <CircularLoader selectedSize={"M"} />
    </div>
  );
};

export default PageLoader;
